import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";

// Font.register({
//   family: "Lato",
//   src: "https://fonts.gstatic.com/s/lato/v16/S6uyw4BMUTPHjxAwXiWtFCfQ7A.woff2"
// });

// Create styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    padding: 10
  },
  section: {
    margin: 10,
    padding: 10
  },
  titleSection: {
    margin: 5,
    padding: 5,
    textAlign: "center"
  },
  title: {
    // fontFamily: "Lato",
    fontSize: 12
  },
  subtitle: {
    // fontFamily: "Lato",
    fontSize: 11,
    color: "#fff"
  },
  subheader: {
    textAlign: "center",
    backgroundColor: "#5B9EAA",
    padding: 5
  },
  image: {
    width: "50%",
    padding: 10,
    textAlign: "center"
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableColHeader: {
    // width: "25%",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol: {
    // width: "25%",
    borderStyle: "solid",
    borderColor: "#bfbfbf",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 10,
    fontWeight: 500
  },
  tableCell: {
    margin: 5,
    fontSize: 10
  }
});

const getSelectedAnswer = (selectedAnswer, key) => {
  if (selectedAnswer !== undefined && selectedAnswer.length > 1) {
    return (
      <View>
        {selectedAnswer.map((answer, i) => {
          return (
            <Text key={`${key}${i}`}>
              {"- "} {answer}
              {"\n"}
            </Text>
          );
        })}
      </View>
    );
  } else {
    return <React.Fragment>{selectedAnswer}</React.Fragment>;
  }
};

const getEducation = (selectedAnswer, answers, sectionName, education, key) => {
  if (typeof selectedAnswer === "object" && selectedAnswer.length === 1) {
    let answerFound = answers.find(
      (answer, idx) => answer === selectedAnswer[0]
    );

    if (answerFound !== undefined && education !== undefined) {
      let index = answers.indexOf(answerFound);

      if (key === "6" && sectionName === "sra:basic") {
        education = education.replace('"accepted"', "'accepted'");
      }
      return (
        <React.Fragment>{JSON.parse(education)[`${index + 1}`]}</React.Fragment>
      );
    }
  }
  return "";
};

// Create Document Component
export default props => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0");
  var yyyy = today.getFullYear();

  today = mm + "/" + dd + "/" + yyyy;

  return (
    <Document>
      <Page wrap size="A4" style={styles.page}>
        <View
          style={Object.assign({}, styles.titleSection, {
            margin: "5px 5px 0 5px"
          })}
          fixed
        >
          <Text style={styles.title}>{props.title}</Text>
        </View>
        <View style={styles.titleSection} fixed>
          <Text style={{ fontSize: 8 }}>
            Generated by: {props.userName} on {today}
          </Text>
        </View>
        <View
          style={Object.assign({}, styles.titleSection, {
            margin: "5px 5px 0 10px"
          })}
        >
          <Text style={{ fontSize: 14 }}>
            Overall Risk Score: {props.overallRisk.riskScore} ||
            {props.overallRisk.riskScore < 11
              ? " Low"
              : this.props.overallRisk.riskScore < 51
              ? " Medium"
              : " High"}{" "}
            Risk
          </Text>
        </View>
        {props.sections.map((section, sectionIdx) => {
          let sectionHeaderEntered = false;
          const sectionFound = props.answers.find(
            questions =>
              questions.backendSectionName === section.backendSectionName
          );

          const questions = sectionFound.questions;

          return (
            <View key={sectionIdx} break={sectionIdx > 0 ? true : false}>
              <View style={styles.titleSection}>
                <Text style={styles.title}>{section.sectionName}</Text>
                <Text style={styles.title}>
                  {section.progress !== 100
                    ? "Section Incomplete"
                    : `Risk Score: ${section.riskScore}`}
                </Text>
              </View>
              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View
                    style={Object.assign({}, styles.tableColHeader, {
                      width: "10%"
                    })}
                  >
                    <Text style={styles.tableCellHeader}>Section</Text>
                  </View>
                  <View
                    style={Object.assign({}, styles.tableColHeader, {
                      width: "35%"
                    })}
                  >
                    <Text style={styles.tableCellHeader}>Question</Text>
                  </View>
                  <View
                    style={Object.assign({}, styles.tableColHeader, {
                      width: "25%"
                    })}
                  >
                    <Text style={styles.tableCellHeader}>Response</Text>
                  </View>
                  <View
                    style={Object.assign({}, styles.tableColHeader, {
                      width: "20%"
                    })}
                  >
                    <Text style={styles.tableCellHeader}>Insights</Text>
                  </View>
                  <View
                    style={Object.assign({}, styles.tableColHeader, {
                      width: "10%"
                    })}
                  >
                    <Text style={styles.tableCellHeader}>Risk</Text>
                  </View>
                </View>
                {Object.keys(questions).map((key, questionIndex) => {
                  let sectionAnswers = [];
                  if (/[0-9]*[a-z]/.test(key)) {
                    sectionAnswers = questions[key].map((answer, i) => {
                      if (answer.selectedAnswer != null) {
                        return (
                          <View key={`${key}${i}`}>
                            {!sectionHeaderEntered
                              ? (sectionHeaderEntered = true && (
                                  <View style={styles.subheader}>
                                    <Text
                                      style={styles.subtitle}
                                    >{`Vulnerabilities & Risk Analysis`}</Text>
                                  </View>
                                ))
                              : null}
                            <View style={styles.tableRow}>
                              <View
                                style={Object.assign({}, styles.tableCol, {
                                  width: "10%"
                                })}
                              >
                                <Text style={styles.tableCell}>
                                  {sectionIdx + 1}
                                </Text>
                              </View>
                              <View
                                style={Object.assign({}, styles.tableCol, {
                                  width: "35%"
                                })}
                              >
                                <Text style={styles.tableCell}>
                                  {answer.question}
                                </Text>
                              </View>
                              <View
                                style={Object.assign({}, styles.tableCol, {
                                  width: "25%"
                                })}
                              >
                                <Text style={styles.tableCell}>
                                  {`Likelihood: ${answer.selectedAnswer.likelihood}`}
                                </Text>
                              </View>
                              <View
                                style={Object.assign({}, styles.tableCol, {
                                  width: "20%"
                                })}
                              >
                                <Text style={styles.tableCell}>
                                  {`Impact: ${answer.selectedAnswer.impact}`}
                                </Text>
                              </View>
                              <View
                                style={Object.assign({}, styles.tableCol, {
                                  width: "10%"
                                })}
                              >
                                <Text style={styles.tableCell}>
                                  {`Risk: ${
                                    answer.selectedAnswer.likelihood === "NA" ||
                                    answer.selectedAnswer.impact === "NA"
                                      ? "NA"
                                      : String(answer.selectedAnswer.risk)
                                  }`}
                                </Text>
                              </View>
                            </View>
                          </View>
                        );
                      } else {
                        return null;
                      }
                    });
                  } else {
                    sectionAnswers = questions[key].selectedAnswer != null && (
                      <View
                        style={styles.tableRow}
                        key={`${key}-${questionIndex}`}
                      >
                        <View
                          style={Object.assign({}, styles.tableCol, {
                            width: "10%"
                          })}
                        >
                          <Text style={styles.tableCell}>{sectionIdx + 1}</Text>
                        </View>
                        <View
                          style={Object.assign({}, styles.tableCol, {
                            width: "35%"
                          })}
                        >
                          <Text style={styles.tableCell}>
                            {questions[key].question}
                          </Text>
                        </View>
                        <View
                          style={Object.assign({}, styles.tableCol, {
                            width: "25%"
                          })}
                        >
                          <Text style={styles.tableCell}>
                            {getSelectedAnswer(
                              questions[key].selectedAnswer,
                              key
                            )}
                          </Text>
                        </View>
                        <View
                          style={Object.assign({}, styles.tableCol, {
                            width: "20%"
                          })}
                        >
                          <Text style={styles.tableCell}>
                            {getEducation(
                              questions[key].selectedAnswer,
                              questions[key].answers,
                              sectionFound.sectionName,
                              questions[key].education,
                              key
                            )}
                          </Text>
                        </View>
                        <View
                          style={Object.assign({}, styles.tableCol, {
                            width: "10%"
                          })}
                        >
                          <Text style={styles.tableCell}></Text>
                        </View>
                      </View>
                    );
                  }
                  return sectionAnswers;
                })}
              </View>
            </View>
          );
        })}
      </Page>
    </Document>
  );
};



// WEBPACK FOOTER //
// ./src/components/sra/components/GenerateReport.js